module.exports = __webpack_public_path__ + "img/networkCarLicense.df077b49.png";